<template>
  <div>
    <el-dialog
      title="Редактирование шаблона"
      :visible.sync="show"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      :show-close="false"
    >
      <div v-loading="loading">
        <cascading-card-scale-edit-form
          :template="template"
        ></cascading-card-scale-edit-form>

      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="show=false">Закрыть</el-button>
      </span>
    </el-dialog>

    <span ref="wrapper">
      <slot name="reference"></slot>
    </span>
  </div>
</template>

<script>

import { off, on } from "element-ui/src/utils/dom";
import CascadingCardScaleEditForm from "@/modules/cascading/components/cardScale/CascadingCardScaleEditForm.vue";

export default {
  name: "CascadingCardScaleTemplateEditModal",
  components: { CascadingCardScaleEditForm },
  props: {
    template: {type: Object, required: true},
  },

  data() {
    return {
      loading: false,
      show: false,
    }
  },
  mounted() {
    if (this.$refs.wrapper.children) {
      on(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  },
  beforeDestroy() {
    if (this.$refs.wrapper.children) {
      off(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  },
  watch: {},
  methods: {
    showModal() {
      this.show = true;
    },
  },


}
</script>